import IDateTime from "../model/interface/api/IDateTime";
import moment, {Moment} from "moment";

export const MomentBuilder = {
    build: (date?: string | IDateTime | Moment | null, format?: string): Moment => typeof date === 'string' ?
        (moment(date).isValid() ? moment(date, format) : moment()) : (moment.isMoment(date) ? date : moment(date?.raw, format))
}